/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import {
  IApplicationMenuScreenModel,
  IApplicationSearchScreenModel,
  ROUTES,
  ScreenType,
  SearchInputPlacement,
  UrlHelper,
  useScreenConfiguration,
} from "@bms/common";
import { useCallback, useMemo, useState } from "react";
import { useHistory } from "react-router";

import { SearchScreenQueryParams } from "../../screens/SearchScreen";

export const useAppSearch = () => {
  const [isFocused, setFocused] = useState(false);

  const searchScreen = useScreenConfiguration<IApplicationSearchScreenModel>(
    ScreenType.Search,
  );

  const menuScreen = useScreenConfiguration<IApplicationMenuScreenModel>(
    ScreenType.ApplicationMenu,
  );

  const history = useHistory();

  const searchComponent = useMemo(
    () =>
      menuScreen?.Components
        ? menuScreen.Components.find(
            (component) =>
              component.IsVisible &&
              component?.Action?.ScreenTypeCode === ScreenType.Search,
          )
        : null,
    [menuScreen?.Components],
  );

  const isApplicationHeaderPlacement =
    searchScreen.InputPlacement !== SearchInputPlacement.ScreenHeader;

  const isApplicationScreenPlacement =
    searchScreen.InputPlacement == SearchInputPlacement.ScreenHeader;

  const searchQuery = UrlHelper.parse(
    history.location.search,
  ) as SearchScreenQueryParams;

  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      e.preventDefault();

      if (location.pathname === ROUTES.SEARCH_SCREEN) {
        history.replace({
          pathname: ROUTES.SEARCH_SCREEN,
          search: UrlHelper.joinQueries(history.location.search, {
            query: e.target.value,
          }),
        });
      } else if (e.target.value.length >= 3) {
        history.push({
          pathname: ROUTES.SEARCH_SCREEN,
          search: UrlHelper.joinQueries({ query: e.target.value }),
        });
      }
    },
    [history],
  );

  const handleOnFocus = useCallback(() => setFocused(true), []);
  const handleOnBlur = useCallback(() => setFocused(false), []);

  return {
    searchQuery,
    isFocused,
    searchComponent,
    isApplicationHeaderPlacement,
    isApplicationScreenPlacement,
    handleChange,
    handleOnFocus,
    handleOnBlur,
  };
};
